import { render, staticRenderFns } from "./AxFilesystemNavigationWorkspace.vue?vue&type=template&id=721c6b4d&scoped=true&"
import script from "./AxFilesystemNavigationWorkspace.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemNavigationWorkspace.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemNavigationWorkspace.vue?vue&type=style&index=0&id=721c6b4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721c6b4d",
  null
  
)

export default component.exports